import { HttpStatusCode, isAxiosError } from 'axios';
import { isIapProtectedUrl, setIapAuthRequired } from 'security/iap';
import { logout, setMessages } from 'store/actions/actions';
import { convertErrors } from 'utils/convertError';
const dispatchErrors = (dispatch, errors) => {
    dispatch(setMessages(errors.map((m) => ({ value: m.message, severity: 'error' }))));
};
class APIAggregateError extends Error {
    subErrors;
    constructor(subErrors) {
        super(`Multiple errors ${subErrors.map((s) => s.message).join(', ')}`);
        this.subErrors = subErrors;
        this.name = 'APIAggregateError';
    }
}
export const createAsyncMiddleware = (state, dispatch) => async (action) => {
    try {
        return await action({
            dispatch,
            state
        });
    }
    catch (error) {
        if (error &&
            isAxiosError(error) &&
            (error.response?.status === HttpStatusCode.Unauthorized ||
                error.response?.status === HttpStatusCode.Forbidden)) {
            if (isIapProtectedUrl(error.config?.url)) {
                setIapAuthRequired();
            }
            else {
                dispatch(logout()); // TODO: Bug risk?
                window.history.pushState('', '', '/signin'); // can't use react-router here, still adds history w/o reload
                return undefined;
            }
        }
        if (isAxiosError(error) && error.response) {
            const errors = convertErrors(error.response.data);
            if (errors.length >= 1) {
                dispatchErrors(dispatch, errors);
            }
            throw new APIAggregateError(errors);
        }
        throw error;
    }
};
